import { render } from "./BadgeColumn.vue?vue&type=template&id=16006e9d"
import script from "./BadgeColumn.vue?vue&type=script&lang=js"
export * from "./BadgeColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__